import { FLOOR_SCREED_CDN_PATH } from 'landings/floor-screed/floor-screed-constants';

export type FloorScreedTypeStructure = {
  imageSrc: string;
  imageAlt: string;
  name: string;
};

export const FLOOR_SCREED_TYPES_LIST: FloorScreedTypeStructure[] = [
  {
    imageSrc: `${FLOOR_SCREED_CDN_PATH}/types/laminate.jpg/laminate.jpg`,
    imageAlt: 'Стяжка пола под ламинат',
    name: 'Под ламинат',
  },
  {
    imageSrc: `${FLOOR_SCREED_CDN_PATH}/types/tile.jpg/tile.jpg`,
    imageAlt: 'Стяжка пола под плитку',
    name: 'Под плитку',
  },
  {
    imageSrc: `${FLOOR_SCREED_CDN_PATH}/types/linoleum.jpg/linoleum.jpg`,
    imageAlt: 'Стяжка пола под линолеум',
    name: 'Под линолеум',
  },
  {
    imageSrc: `${FLOOR_SCREED_CDN_PATH}/types/parquet.jpg/parquet.jpg`,
    imageAlt: 'Стяжка пола под паркетную доску',
    name: 'Под паркетную доску',
  },
];
